/**
 * Created by daniesy on 12/04/2017.
 */
import ShortcutsHandler from './shortcutsHandler.js';
import NewsletterHandler from './newsletterHandler';
import LocaleHandler from './localeHandler';

class Application {

    constructor(locale = 'en', checkSession = false) {
        this.newsletterHandler = new NewsletterHandler();
        this.localeHandler = new LocaleHandler(locale);
        this.addEvents(checkSession);
    }

    addEvents(checkSession = false) {
        document.addEventListener('DOMContentLoaded', this.constructor.pageLoaded);
        setTimeout(Application.addFormEvents, 500);
        if (checkSession) {
            window.addEventListener("focus", this.constructor.checkAuth, false);
        }
    }

    static addFormEvents() {
        var forms = document.querySelectorAll("form:not(.no-block)");
        forms.forEach(function(form) {
            form.addEventListener('submit', Application.formSubmitted);
        });
    }

    static formSubmitted(e) {
        var submitButtons = e.target.querySelectorAll("button[type=submit],input[type=submit]");
        submitButtons.forEach(function(submitButton) {
            if (submitButton.tagName === "INPUT") {
                submitButton.dataset.oldValue = submitButton.value;
                submitButton.value = "Please wait...";
            } else {
                submitButton.dataset.oldInner = submitButton.innerHTML;
                submitButton.innerHTML = '<i class="fa fa-circle-o-notch fa-spin fa-fw"></i>';
            }
            submitButton.classList.add('submit-disabled');
            submitButton.disabled = true;
        });

        var overlay = document.createElement("div");
        overlay.className = "submit-overlay";
        document.body.appendChild(overlay);
    }

    resetFormBlock() {
        var submitButtons = document.body.querySelectorAll(".submit-disabled");
        submitButtons.forEach(function(submitButton) {
            submitButton.disabled = false;
            submitButton.classList.remove('submit-disabled');
            if (submitButton.dataset.oldInner) {
                submitButton.innerHTML = submitButton.dataset.oldInner;
            } else if (submitButton.dataset.oldValue) {
                submitButton.value = submitButton.dataset.oldValue;
            }
        });
        document.querySelector('.submit-overlay').remove();
    }

    static pageLoaded() {
        document.body.removeAttribute('v-cloak');
    }

    static createNotification(type, body, timeout = 15) {
        window.notificationObject = {
            type,
            body,
            timeout
        }
    }

    static checkAuth() {
        return "";
        var xhr = new XMLHttpRequest();
        xhr.open('POST', "/system/check-auth", true);
        xhr.setRequestHeader('X-CSRF-TOKEN', document.head.querySelector('meta#csrf-token').getAttribute("content"));
        xhr.send();

        var redirectToLogin = function() {
            document.body.className += " session-expired";
            setTimeout(function() {
                window.location.href = "/login";
            }, 2000);
        };

        xhr.addEventListener("readystatechange", function(e) {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    var response = JSON.parse(xhr.responseText);
                    if (!response.auth) {
                        redirectToLogin();
                    } else {
                        console.log("ok");
                    }
                } else {
                    redirectToLogin();
                }
            }
        }, false);
    }

}

window.Application = Application;
